import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import api from '../services/api'
import { EVENT_NAME } from '../constants/branding'
import './RssFeed.css'

export default function RssFeed() {
  const [rssContent, setRssContent] = useState<string>('')
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const fetchRss = async () => {
      try {
        setLoading(true)
        const response = await api.get('/rss', {
          responseType: 'text',
          headers: {
            'Accept': 'application/rss+xml, application/xml, text/xml'
          }
        })
        setRssContent(response.data)
        setError(null)
      } catch (err: any) {
        console.error('Failed to fetch RSS feed:', err)
        setError(err.response?.data?.error || 'Failed to load RSS feed')
      } finally {
        setLoading(false)
      }
    }

    fetchRss()
  }, [])

  if (loading) {
    return <div className="rss-feed">Loading RSS feed...</div>
  }

  if (error) {
    return (
      <div className="rss-feed">
        <h1>{EVENT_NAME} RSS Feed</h1>
        <div className="error-message">{error}</div>
      </div>
    )
  }

  // Parse RSS XML (simple parser for display)
  const parser = new DOMParser()
  const xmlDoc = parser.parseFromString(rssContent, 'text/xml')
  const items = xmlDoc.querySelectorAll('item')
  const channel = xmlDoc.querySelector('channel')
  const title = channel?.querySelector('title')?.textContent || 'RSS Feed'
  const description = channel?.querySelector('description')?.textContent || ''
  const copyright = channel?.querySelector('copyright')?.textContent || ''

  return (
    <div className="rss-feed">
      <h1>{title}</h1>
      <p className="rss-description">{description}</p>
      {copyright && <p className="rss-copyright">{copyright}</p>}
      
      <div className="rss-items">
        {Array.from(items).map((item, index) => {
          const itemTitle = item.querySelector('title')?.textContent || ''
          const itemLink = item.querySelector('link')?.textContent || ''
          const itemDescription = item.querySelector('description')?.textContent || ''
          const itemPubDate = item.querySelector('pubDate')?.textContent || ''
          
          // Extract game ID from link
          const gameIdMatch = itemLink.match(/\/games\/(\d+)/)
          const gameId = gameIdMatch ? gameIdMatch[1] : null

          return (
            <div key={index} className="rss-item">
              <div className="rss-item-content">
                <h3 className="rss-item-title">
                  {gameId ? (
                    <Link to={`/games/${gameId}`}>{itemTitle}</Link>
                  ) : (
                    <a href={itemLink} target="_blank" rel="noopener noreferrer">
                      {itemTitle}
                    </a>
                  )}
                </h3>
                {itemDescription && (
                  <p className="rss-item-description">{itemDescription}</p>
                )}
                {itemPubDate && (
                  <p className="rss-item-date">
                    {new Date(itemPubDate).toLocaleString()}
                  </p>
                )}
              </div>
            </div>
          )
        })}
      </div>

      <div className="rss-raw">
        <details>
          <summary>View Raw RSS XML</summary>
          <pre className="rss-xml">{rssContent}</pre>
        </details>
      </div>
    </div>
  )
}

